import styled from 'styled-components';
import { StyledActions } from './Actions/Actions.style';

export const StyledTitle = styled.div`
  font-size: 2rem;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & ${StyledActions} {
    margin-left: auto;
  }
`;

export const StyledHeader = styled.header``;
